import React, { useState } from 'react';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
// import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import getUnixTimestamp from '../../../util/getUnixTimestamp';
import css from './NewDatePicker.module.css';
import moment from 'moment';
import 'moment/locale/es'; // Import Spanish locale
import DateSelect from './DateSelect';

// Extend dayjs with the necessary plugins
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.locale('es'); // Set dayjs locale to Spanish

export default function DatePickerValue(props) {
  const { form, monthlyTimeSlots = {}, intl } = props;
  const [startDate, setStartDate] = useState(null); // Store start date
  const [endDate, setEndDate] = useState(null); // Store start date

  const getAvailableDates = () => {
    const blockedDates = new Set();

    if (typeof monthlyTimeSlots !== 'object' || monthlyTimeSlots === null) {
      console.error('monthlyTimeSlots is not an object or is null');
      return blockedDates;
    }

    let minDate = dayjs.tz(dayjs(), 'Europe/Madrid'); // Current date and time in Madrid timezone
    const maxDate = minDate.add(3, 'month'); // Date 3 months after minDate

    for (
      let date = minDate.startOf('day');
      date.isBefore(maxDate.add(1, 'day'));
      date = date.add(1, 'day')
    ) {
      blockedDates.add(date.format('YYYY-MM-DD'));
    }

    Object.values(monthlyTimeSlots).forEach(monthData => {
      if (Array.isArray(monthData.timeSlots)) {
        monthData?.timeSlots?.forEach(timeSlot => {
          const startDate = dayjs.utc(timeSlot.attributes.start).tz('Europe/Madrid');
          const endDate = dayjs.utc(timeSlot.attributes.end).tz('Europe/Madrid');

          for (
            let date = startDate.startOf('day');
            date.isBefore(endDate.add(1, 'day'));
            date = date.add(1, 'day')
          ) {
            blockedDates.delete(date.format('YYYY-MM-DD'));
          }
        });
      } else {
        console.error('timeSlots is not an array or is undefined in monthData:', monthData);
      }
    });

    return blockedDates;
  };

  const blockedDates = getAvailableDates();
  // console.log(JSON.stringify(blockedDates));

  const convertDate = originalDateString => {
    const date = moment(originalDateString, 'ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    const formattedDate = date.tz('Europe/Madrid').format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
    return formattedDate;
  };

  // Start date change handler

  const renderFormatedDate = date => {
    const dateFormattingOptions = { month: 'short', day: 'numeric', weekday: 'short' };
    const startDatePlaceholder = intl.formatDate(date, dateFormattingOptions);
    return startDatePlaceholder;
  };
  var today = new Date();
  const newWeekAdd7Days = new Date(today).setDate(today.getDate() + 7);
  const [valueStart, setValueStart] = useState(renderFormatedDate(new Date()));
  const [valueEnd, setValueEnd] = useState(renderFormatedDate(newWeekAdd7Days));

  const startFun = newValue => {
    form.change('endDateError', null);
    form.change('startDateError', null);
    const evValue = newValue?.target?.value;
    const valueTarget = evValue ? evValue : newValue;
    const selectedStartDate = dayjs
      .tz(valueTarget, 'Europe/Madrid')
      .set('hour', 9) // Set hour to 10 AM
      .set('minute', 0) // Set minute to 0
      .set('second', 0); // Set to start of the day
    setStartDate(selectedStartDate); // Store the selected start date in state
    setValueStart(renderFormatedDate(selectedStartDate));
    form.batch(() => {
      // form.change('bookingEndDate', { date: null });
      // form.change('bookingEndTime', null);
      form.change('bookingStartTime', getUnixTimestamp(String(selectedStartDate)));
      form.change('bookingStartDate', { date: convertDate(String(selectedStartDate)) });

      // Clear the end date to force the user to pick a new one
    });
  };

  // End date change handler (actual logic happens here)
  const endFun = newValue => {
    form.change('endDateError', null);
    form.change('startDateError', null);

    if (!startDate) {
      console.error('Start date is not set before end date');
      return;
    }
    const evValue = newValue?.target?.value;
    const valueTarget = evValue ? evValue : newValue;

    const selectedEndDate = dayjs
      .tz(valueTarget, 'Europe/Madrid')
      .set('hour', 21) // Set hour to 10 AM
      .set('minute', 0) // Set minute to 0
      .set('second', 0);
    setValueEnd(renderFormatedDate(selectedEndDate));
    setEndDate(selectedEndDate); // Store the selected start date in state
    form.batch(() => {
      form.change('bookingEndTime', getUnixTimestamp(String(selectedEndDate)));
      form.change('bookingEndDate', { date: convertDate(String(selectedEndDate)) });
    });
  };

  const shouldDisableDate = date => {
    return blockedDates.has(date.format('YYYY-MM-DD')); // Disable if in blockedDates
  };

  moment.locale('es');

  return (
    <>
      {/* <LocalizationProvider dateAdapter={AdapterDayjs}> */}
      <div className={css.inputsDateContainer}>
        <div className={css.each_container}>
          <DateSelect
            label={intl.formatMessage({ id: 'BookingDatesForm.bookingStartTitle' })}
            onChange={startFun}
            value={valueStart}
            defaultValue={valueStart}
            valueInput={valueStart}
            currentDate={startDate}
            intl={intl}
            monthlyTimeSlots={monthlyTimeSlots}
            minDate={new Date()}
          />
        </div>
        <div className={css.each_container}>
          <DateSelect
            onChange={endFun}
            value={valueEnd}
            defaultValue={valueEnd}
            valueInput={valueEnd}
            label={intl.formatMessage({ id: 'BookingDatesForm.bookingEndTitle' })}
            intl={intl}
            currentDate={endDate}
            monthlyTimeSlots={monthlyTimeSlots}
            minDate={startDate ? startDate.add(0, 'day').toDate() : new Date()}
          />
        </div>
      </div>
      {/* <DemoContainer components={['DatePicker', 'DatePicker']}>
          <div className="">
            <DatePicker
              onChange={startFun}
              shouldDisableDate={shouldDisableDate}
              label={intl.formatMessage({ id: 'BookingDatesForm.bookingStartTitle' })}
              defaultValue={dayjs(new Date()).add(0, 'day')}
              // defaultValue={dayjs('2000-10-25')}
            />
          </div>
          <div className="">
            <DatePicker
              onChange={endFun}
              shouldDisableDate={shouldDisableDate}
              label={intl.formatMessage({ id: 'BookingDatesForm.bookingEndTitle' })}
              defaultValue={dayjs(new Date()).add(5, 'day')}
            />
          </div>
        </DemoContainer> */}
      {/* </LocalizationProvider> */}
    </>
  );
}
